import * as THREE from "three";
import { Canvas, extend, useFrame } from "@react-three/fiber";
import { shaderMaterial, useVideoTexture, OrbitControls } from "@react-three/drei";
import { useRef } from "react";

// Création du Shader Material pour enlever le vert
const ChromaKeyMaterial = shaderMaterial(
  { map: null, keyColor: new THREE.Vector3(0.0, 1.0, 0.0), threshold: 0.4, softness: 0.1 },
  `
  varying vec2 vUv;
  uniform sampler2D map;

  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
  `,
  `
varying vec2 vUv;
uniform sampler2D map;
uniform vec3 keyColor;
uniform float threshold;
uniform float softness;

void main() {
    vec4 color = texture2D(map, vUv);

    // Distance entre le pixel et la couleur verte clé
    float dist = distance(color.rgb, keyColor);

    // Calcul de l'alpha : Plus un pixel est proche du vert, plus il devient transparent
    float alphaFactor = smoothstep(threshold, threshold + softness, dist);
    color.a *= alphaFactor; // Applique la transparence proportionnelle

    // Suppression du vert résiduel tout en gardant l'opacité originale
    float greenAmount = color.g * (1.0 - alphaFactor); // Garde la part non "chromakéed"
    color.rgb -= vec3(greenAmount * 0.8, greenAmount * 0.9, greenAmount * 0.8); 

    gl_FragColor = color;
}
  `
);

extend({ ChromaKeyMaterial });

export default function VideoPlane(props) {
  const videoTexture = useVideoTexture(import.meta.env.BASE_URL + 'static/videos/LCO-CT V2.mp4')
  const materialRef = useRef();

  return (
    <mesh {...props}>
      <planeGeometry args={[4, 2.5]} />
      <meshBasicMaterial map={videoTexture} />
    </mesh>
  );
}
